
















import { Component, Vue } from "vue-property-decorator";
import chat_sidebar from "@/components/chat/chat_sidebar.vue";

@Component({
  components: {
    chat_sidebar,
  },
})
export default class chat_gpt_inp extends Vue {
  created() {}
}
